<template>
    <div>
        <div class="alert__modal">
            <div>
                <div class="alert__modal__title">
                    <p>{{title ? title : '알림'}}</p>
                </div>
                <div class="alert__modal__content">{{content}}</div>
                <div class="alert__modal__bottom">
                    <div class="width-100" @click="close">닫기</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props: ['title', 'content'],
        methods:{
            close(){
                this.$emit('close')
            }
        }
    }
</script>
